import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

export type PeriodType = 'ENTIRE_PERIOD' | 'SELECTED_RANGE';

const PERIOD_RANGE_RADIO_ITEMS: RadioGroupItem<PeriodType>[] = [
   {
      id: 'ENTIRE_PERIOD',
      label: medicalDocumentationCreateTranslationKeys.entirePeriod,
   },
   {
      id: 'SELECTED_RANGE',
      label: medicalDocumentationCreateTranslationKeys.selectedRange,
   },
];

type PeriodRangeRadioGroupProps = FieldControllerProps<'periodRange', PeriodType> & ClassNameProp;

export const PeriodRangeRadioGroup = (props: PeriodRangeRadioGroupProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <RadioGroup<PeriodType> testId={props.name} items={PERIOD_RANGE_RADIO_ITEMS} controller={controller} horizontal />
   );
};
